import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  static get observedAttributes() {
    return ['text-to-copy'];
  }


  connectedCallback() {
    if (super.connectedCallback) {
      super.connectedCallback();
    }


    const button = this.querySelector('button');
    if (button) {
      button.addEventListener('click', () => this.copyToClipboard());
    }
  }

  copyToClipboard() {

    const copyContent = this.props?.['text-to-copy'] || this.getAttribute('text-to-copy');
    
   

    if (!copyContent) {
      console.warn("复制失败：未在标签上找到有效的 text-to-copy 属性值。");
      return;
    }

    navigator.clipboard.writeText(copyContent)
      .then(() => {
        console.log("复制到剪贴板成功！");
        

        const copySuccessMessage = this.refs?.copySuccessMessage || this.querySelector('[ref="copySuccessMessage"]');

        if (copySuccessMessage instanceof Element) {
          copySuccessMessage.classList.remove('visually-hidden');

          setTimeout(() => {
            copySuccessMessage.classList.add('visually-hidden');
          }, 3000);
        }
      })
      .catch(err => {
        console.error('navigator.clipboard 复制失败，尝试降级兼容处理', err);

        const textArea = document.createElement("textarea");
        textArea.value = copyContent;
        textArea.style.position = "fixed";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          const copySuccessMessage = this.refs?.copySuccessMessage || this.querySelector('[ref="copySuccessMessage"]');
          if (copySuccessMessage) copySuccessMessage.classList.remove('visually-hidden');
        } catch (e) {
          console.error('所有复制渠道均不可用', e);
        }
        document.body.removeChild(textArea);
      });
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}